import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser, fetchAuthSession } from '@aws-amplify/auth';

const Callback = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get the authenticated user
        const user = await getCurrentUser();
        const session = await fetchAuthSession();
        
        const idToken = session.tokens?.idToken;
        const payload = idToken?.payload || {};
        
        // Extract role from custom:accessrole
        const accessRoles = payload['custom:accessrole'] || '';
        const roles = accessRoles.split(',').map(role => role.trim());
        const assignedRole = roles.includes('Carson_AdminUser') ? 'Carson_AdminUser' : 'Carson_TechUser';
        
        const userData = {
          id: payload.preferred_username || user.username,
          username: `${payload.given_name || ''} ${payload.family_name || ''}`.trim() || user.username,
          name: payload.name || payload.given_name || user.username,
          email: payload.email || 'N/A',
          role: assignedRole
        };
        
        // Store user data and token in session storage
        sessionStorage.setItem('userInfo', JSON.stringify(userData));
        sessionStorage.setItem('token', idToken.toString());
        
        // Trigger storage event to notify AuthContext
        window.dispatchEvent(new Event('storage'));
        
        // Navigate to dashboard
        navigate('/dashboard');
      } catch (error) {
        console.error('Callback error:', error);
        setError('Authentication failed. Please try again.');
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
      }}
    >
      <CircularProgress size={60} />
      <Typography variant="h6" sx={{ mt: 2 }}>
        {error ? error : 'Signing you in...'}
      </Typography>
    </Box>
  );
};

export default Callback;